var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"primary":"","small":""},on:{"click":_vm.addProduct}},[_vm._v(" Add Product ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }